// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"18ae2e9c","732":"92baec1f","977":"61e91bdb"}[chunkId] + ".chunk.js";
};